import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutboundCall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 40,
	viewBox: "0 0 41 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .666626,
			width: 40,
			height: 40,
			rx: 20,
			fill: "#ECFDF5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2975_35407)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M29.6666 24.42V27.9561C29.6666 28.4811 29.2607 28.9167 28.7371 28.9537C28.2997 28.9846 27.9429 29 27.6666 29C18.83 29 11.6666 21.8366 11.6666 13C11.6666 12.7237 11.6821 12.3669 11.713 11.9295C11.75 11.4059 12.1856 11 12.7105 11H16.2467C16.5034 11 16.7184 11.1944 16.7442 11.4498C16.7673 11.6791 16.7888 11.8631 16.8087 12.002C17.011 13.4147 17.4242 14.7594 18.0153 16.003C18.1102 16.2026 18.0483 16.4416 17.8685 16.5701L15.7102 18.1118C17.0241 21.1811 19.4855 23.6425 22.5548 24.9565L24.0937 22.8019C24.2238 22.6199 24.4656 22.5573 24.6676 22.6532C25.9112 23.2439 27.2557 23.6566 28.6682 23.8584C28.8062 23.8782 28.9891 23.8995 29.2168 23.9225C29.4722 23.9483 29.6666 24.1633 29.6666 24.42Z",
				fill: "#059669"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M28.3353 13.0994L23.6734 17.7613L22.9073 16.9952L27.5693 12.3333H23.4603V11.25H29.4186V17.2083H28.3353V13.0994Z",
				fill: "#059669"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2975_35407",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8.66663 8)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgOutboundCall);
export { ForwardRef as ReactComponent };
